module.exports = __webpack_public_path__ + "4f20b871c41c0db18aed6028617f6dce.pdf";